import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import { CurrencySquareChip, DateSquareChip } from 'app/main/components/list-items';
import buttons from './OrdersButtons';

export default function OrdersListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="companies"
			uid={props.model.ords_comp_uid}
			avatar={props.model.comp_avatar}
			initials={props.model.ords_title_initials}
			labelBadge={props.model.orst_title_initials}
			labelBadgeTooltip={props.model.orst_title}
			badgeColor={props.model.orst_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 6 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.ords_warning_desc && (
								<Tooltip title={props.model.ords_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.ords_blocked_desc && (
								<Tooltip title={props.model.ords_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'orders', uid: props.model.ords_uid }}
							>
								{props.model.ords_title}
								{props.model.comp_title && ` - ${props.model.comp_title}`}
							</Text>
						</Grid>
						{/* COMPANY RELATION */}
						<Grid>
							{props.model.core_title && (
								<SquareChip label={props.model.core_title} backgroundColor={props.model.core_color} />
							)}
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.orty_title && (
								<SquareChip label={props.model.orty_title} backgroundColor={props.model.orty_color} />
							)}
						</Grid>
						{/* SIGN DATE */}
						<Grid>
							<DateSquareChip value={props.model.ords_d_sign} />
						</Grid>
						{/* TOT TAX EXCL */}
						<Grid>
							<CurrencySquareChip
								id="ordersListItem.totTaxExcl"
								defaultMessage={t('TOT_VALUE_TAX_EXCLUDED')}
								value={props.model.ords_tot_value_tax_excl}
							/>
						</Grid>
						{/* TOT TAX INCL */}
						{/* <Grid>
							<CurrencySquareChip
								id="ordersListItem.totTaxIncl"
								defaultMessage={t('TOT_VALUE_TAX_INCLUDED')}
								value={props.model.ords_tot_value_tax_incl}
							/>
						</Grid> */}
						{/* TAGS */}
						<Grid size={12}>
							<TagsArray tags={props.model.ords_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={props.width >= 960 ? 3 : 6}>
						<Grid container>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={
										props.model.ords_user_assigned_uid &&
										`/users/details/${props.model.ords_user_assigned_uid}`
									}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title || props.model.ords_user_assigned_title}
								</ButtonLink>
							</Grid>
							{/* EXTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={
										props.model.ords_user_assigned_2_uid &&
										`/users/details/${props.model.ords_user_assigned_2_uid}`
									}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_EXTUSER')}
								>
									{props.model.user_assigned_2_title || props.model.ords_user_assigned_2_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
				{props.width >= 960 && (
					<Grid size={3}>
						<Grid container>
							{/* PAYMENT TERMS */}
							<Grid>
								{props.model.pate_title && (
									<SquareChip
										label={props.model.pate_title}
										backgroundColor={props.model.pate_color}
									/>
								)}
							</Grid>
							{/* PAYMENT METHOD */}
							<Grid>
								{props.model.pame_title && (
									<SquareChip
										label={props.model.pame_title}
										backgroundColor={props.model.pame_color}
									/>
								)}
							</Grid>
							{/* SHIPPING METHOD */}
							<Grid>
								{props.model.shme_title && (
									<SquareChip
										label={props.model.shme_title}
										backgroundColor={props.model.shme_color}
									/>
								)}
							</Grid>
							{/* SHIPPING AGENT */}
							<Grid>
								{props.model.shag_title && (
									<SquareChip
										label={props.model.shag_title}
										backgroundColor={props.model.shag_color}
									/>
								)}
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
